module.exports = __webpack_public_path__ + "img/GoogleAdsLogoSmall.6a32cd22.png";